module.exports = __webpack_public_path__ + "static/media/closeblue.cb9a76b4.svg";